module.exports = __webpack_public_path__ + "static/media/icon-calendar-white.58647249.svg";